import { apiClient } from "../config";
async function getUserNotificationPreferences(id: any) {
  const queryString = id ? `?user_id=${id}` : "";
  const res = await apiClient.get(`/admin/users/profile/notification${queryString}`);
  return res.data;
}

export default getUserNotificationPreferences;
